// extracted by mini-css-extract-plugin
export default {"container":"ShareMessageBtn_container__iuEqA"};